import { Stack } from "@similarweb/ui-components/foundations";

import { AlertsErrorBoundary } from "../AlertsErrorBoundary";
import type { AlertViewMode } from "../tabs/viewModeConfig";
import { WebsiteContentAlertsFilters } from "../website-content-alerts/filters/WebsiteContentAlertsFilters";
import { WebsiteContentAlertsFeed } from "../website-content-alerts/WebsiteContentAlertsFeed";
import { WebsiteContentMetrics } from "../website-content-alerts/WebsiteContentMetrics";

type WebsiteContentPanelProps = {
    viewMode: AlertViewMode;
};

export const WebsiteContentPanel = ({ viewMode }: WebsiteContentPanelProps) => (
    <Stack
        gap="32px"
        flexGrow={1}
    >
        {viewMode === "feed" ? <WebsiteContentAlertsFilters /> : null}
        <AlertsErrorBoundary
            alertType="websiteContent"
            viewMode={viewMode}
        >
            {viewMode === "feed" ? <WebsiteContentAlertsFeed /> : <WebsiteContentMetrics />}
        </AlertsErrorBoundary>
    </Stack>
);
